<template>
<div class="audit-list page-box">
  <query-header
    ref="header"
    :type-list="typeList"
    @toQuery="toQuery"
  ></query-header>
  <div class="page-content">
    <div class="content-header">
      <el-input
        class="search-input"
        v-model="login"
        :placeholder="$t('transaction_account')"
        clearable
      ></el-input>
      <vs-button
        class="search-btn"
        @click="searchHandle"
      >{{$t('search')}}</vs-button>
    </div>
    <div class="vs-table-outer">
      <vs-table :noDataText="$t('root.noData')" :data="listData">
        <template
          slot="thead">
          <vs-th>
            {{$t('serial_number_num')}}
          </vs-th>
          <vs-th>
            {{$t('transaction_account')}}
          </vs-th>
          <vs-th>
            {{$t('Operation_type')}}
          </vs-th>
          <vs-th>
            {{$t('Operation_method')}}
          </vs-th>
          <vs-th>
            {{$t('User.amount')}}(USD)
          </vs-th>
          <vs-th>
            {{$t('withgold.status')}}
          </vs-th>
          <vs-th>
            {{$t('remark')}}
          </vs-th>
          <vs-th>
            {{$t('User.applyTime')}}
          </vs-th>
          <vs-th>
            {{$t('review_time')}}
          </vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(tr, index) in data" >
            <vs-td>
              {{tr.id}}
            </vs-td>
            <vs-td>
              {{tr.login}}
            </vs-td>
            <vs-td>
              {{getType(tr)}}
            </vs-td>
            <vs-td>
              {{tr.desc || '-'}}
            </vs-td>

            <vs-td>
              {{ tr.amount }}
            </vs-td>
            <vs-td>
            <span
              class="tag-box"
              :style="getStyle(tr)"
            >{{getStatus(tr)}}</span>
            </vs-td>
            <vs-td
              class="reject-reason"
            >
              {{tr.rejectReason || '-'}}
            </vs-td>
            <vs-td>
              {{tr.createTime}}
            </vs-td>
            <vs-td>
              <span v-if="getShortShow(tr)">-</span>
              <span v-else>{{parseTime(tr.statusTime)}}</span>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
    <div class="pagination-outer" v-if="total">
      <div class="paginnation-left">
        <size-change @sizeChange="sizeChange"></size-change>
        <span class="tatol-count">{{$t('total')}} {{total}} {{$t('item')}}</span>
      </div>
      <vs-pagination
        class="pagination-box"
        :max="max"
        :total="pageSize"
        v-model="page"
      ></vs-pagination>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { colorRgba,parseTime } from '@/utils/index'
import initData from "@/mixins/initData";
import queryHeader from "@/components/auditList/queryHeader";
export default {
  name: "index",
  components: {
    queryHeader,
  },
  data() {
    return {
      login: '',
      typeList: [],
      red: '#D85E5F',
      green: '#41B883',
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo']),
  },
  mounted(){
    this.init().then((res) => {
      this.typeList = res.data.statistics.typeList;
    });
  },
  methods: {
    parseTime,
    beforeInit(){
      this.url = '/crm/reception/partner/queryDepositOrWithdraw';
      this.params = {
        page: this.page - 1,
        size: this.size,
        custId: this.userInfo.id,
        loginType: 0,
        // status: 6, // todo
      }
      let header = this.$refs.header;
      if(header.way){
        this.params.dataType = header.way;
      }
      if(header.type){
        this.params.payType = header.type;
      }
      if(header.date){
        this.params.startTime = header.date[0];
        this.params.endTime = header.date[1];
      }
      if(header.status !== ''){
        this.params.status = header.status;
      }
      if(this.login){
        this.params.login = this.login;
      }
      return true;
    },
    getType(item){
      if(item.type == 1){
        return this.$t('Trade.depo');// 入金
      }else if(item.type == 2){
        return this.$t('User.out');// 出金
      }
    },
    getStatus(tr){
      switch (tr.status) {
        case 6:
          return this.$t('User.authPass');
        case 99:
          return this.$t('Audit_Reject');
        default:
          return this.$t('User.custStatus3')
      }
    },
    getStyle(tr){
      if(tr.status == 6){
        return {
          backgroundColor: colorRgba(this.green,0.1),
          color: this.green,
        };
      }else if(tr.status == 99){
        return {
          backgroundColor: colorRgba(this.red ,0.1),
          color: this.red,
        };
      }else {
        return {
          backgroundColor: colorRgba(this.themeColor,0.1),
          color: this.themeColor,
        };
      }
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
    getShortShow(tr){
      if(tr.status != 6 && tr.status != 99){
        return true;
      }else {
        return false;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.audit-list {
  .vs-table-outer {
    .vs-con-table {
      min-width: 1200px;
    }
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
  .reject-reason {
    max-width: 120px;
  }
}
</style>
